import { ShieldCheck, Lock, BadgeCheck } from 'lucide-react';

const DEFAULT_BADGES = [
  { icon: Lock, label: 'Secure, encrypted form' },
  { icon: ShieldCheck, label: 'No lead diversion' },
  { icon: BadgeCheck, label: 'Verified casahom team' },
];

export function TrustBadges({ items = DEFAULT_BADGES, className = '' }) {
  return (
    <ul className={`space-y-2.5 ${className}`}>
      {items.map((b) => (
        <li key={b.label} className="flex items-center gap-2 text-xs text-slate-500">
          <b.icon size={14} className="shrink-0 text-blue-600" />
          {b.label}
        </li>
      ))}
    </ul>
  );
}
